<template>
  <div>
    <div v-for="(work, w) in works" :key="'workTypes' + w" class="grid fw500">
      <div class="cell">{{ w + 1 }}</div>
      <div class="grid_inner">
        <div class="cell">
          {{
            work.is_hourly === 1
              ? $formatTime(work['employee_report'])
              : formatNumber(work['employee_report']) + ' ' + work.measure
          }}
        </div>
        <div class="cell">
          {{
            work['approved_report'] > 0
              ? work.is_hourly === 1
                ? $formatTime(work['approved_report'])
                : formatNumber(work['approved_report']) + ' ' + work.measure
              : ''
          }}
        </div>
        <div class="cell one_col">{{ work.name }}</div>
      </div>
    </div>
    <template v-if="extras.length > 0">
      <div class="grid fw500">
        <div class="cell">{{ works.length + 1 }}</div>
        <div class="grid_inner">
          <div class="cell">
            {{ $formatTime(getSumByField(extras, 'employee_report')) }}
          </div>
          <div class="cell">
            {{
              getSumByField(extras, 'approved_report') > 0
                ? $formatTime(getSumByField(extras, 'approved_report'))
                : ''
            }}
          </div>
          <div class="cell one_col">{{ localStorage.translations.pages.finance['period-table']['total-extra'] }}</div>
        </div>
      </div>
      <div v-for="(extra, e) in extras" :key="'extras' + e" class="grid">
        <div class="cell">{{ works.length + 1 }}.{{ e + 1 }}</div>
        <div class="grid_inner">
          <div class="cell">{{ $formatTime(extra['employee_report']) }}</div>
          <div class="cell">
            {{ extra['approved_report'] > 0 ? $formatTime(extra['approved_report']) : '' }}
          </div>
          <div class="cell one_col">{{ extra.name }}</div>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: "StatisticProjectReportsBlankExcelTableTotal",
  props: {
    works: {
      type: Array,
      default: () => {
        return []
      }
    },
    extras: {
      type: Array,
      default: () => {
        return []
      }
    },
  },
  methods: {
    getSumByField(items, field) {
      return Object.values(items).reduce((sum, current) => {
        return sum + current[field]
      }, 0)
    },
  
    formatNumber(num) {
      return Math.round(num * 100) / 100
    },
  }
}
</script>
